export default {
  title: "Мои выставки",
  archivedEvents: "Архив",

  loadingMessage: "Загрузка выставок...",
  noEventsMessage: "У вас нет доступных выставок",

  inviteInputPlaceholder: "Введите код участника",
  popupOrderQuestion: "Вы точно хотите отменить заказ?",
  popupClassicDelete: "Удалить",
  popupOrderDelete: "Да",
  popupOrderCancel: "Нет",
  popupClassicCancel: "Отмена"
};
